"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePasswordWrapper = exports.ChangePasswordView = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChangePasswordView = exports.ChangePasswordView = _styledComponents["default"].div.withConfig({
  displayName: "styles__ChangePasswordView",
  componentId: "sc-1p9thce-0"
})(["align-items:center;display:flex;flex-direction:column;flex:1;justify-content:center;padding:20px 0;background:#ffffff;"]);
var ChangePasswordWrapper = exports.ChangePasswordWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ChangePasswordWrapper",
  componentId: "sc-1p9thce-1"
})(["display:flex;flex-direction:column;"]);
//# sourceMappingURL=styles.js.map